/**
 * PageContainer Component
 * Standardized page-level container with consistent spacing
 */

import React from 'react';
import { spacing } from '../../styles/spacing';

export interface PageContainerProps {
  children: React.ReactNode;
  maxWidth?: 'full' | 'container' | '7xl' | '6xl';
  spacing?: 'default' | 'compact' | 'spacious';
  className?: string;
}

const maxWidthClasses = {
  full: 'w-full',
  container: 'container mx-auto',
  '7xl': 'max-w-7xl mx-auto',
  '6xl': 'max-w-6xl mx-auto',
};

const spacingClasses = {
  default: 'p-6 space-y-6',
  compact: 'p-4 space-y-4',
  spacious: 'p-8 space-y-8',
};

export function PageContainer({
  children,
  maxWidth = 'container',
  spacing: spacingVariant = 'default',
  className = '',
}: PageContainerProps) {
  return (
    <div className={`${maxWidthClasses[maxWidth]} ${spacingClasses[spacingVariant]} ${className}`}>
      {children}
    </div>
  );
}

